import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section id="cta" className="py-10 md:py-32 bg-charcoal relative overflow-hidden" data-id="element-71">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-64 bg-sand/10 blur-[100px] pointer-events-none" data-id="element-72"></div>

      <div className="max-w-3xl mx-auto px-6 text-center relative z-10" data-id="element-73">
        <FadeIn data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-8 md:mb-12" data-id="element-75">
            Hay 2 opciones después de leer esto.
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8 mb-10 md:mb-16 text-left" data-id="element-76">
          <FadeIn delay={0.2} className="bg-charcoal-dark border border-charcoal-light p-8 rounded-sm opacity-70" data-id="element-77">
            <h3 className="text-xl font-heading font-bold text-offwhite-dim mb-4" data-id="element-78">
              Opción 1
            </h3>
            <p className="text-offwhite-dim" data-id="element-79">
              Cerrás esto, decís <em data-id="element-80">"lo hago después"</em>… y en 3 semanas
              seguís en el mismo loop.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} className="bg-charcoal-dark border border-sand/50 p-8 rounded-sm shadow-[0_0_30px_rgba(212,165,116,0.1)]" data-id="element-81">
            <h3 className="text-xl font-heading font-bold text-sand mb-4" data-id="element-82">
              Opción 2
            </h3>
            <p className="text-offwhite" data-id="element-83">
              Escribís <strong data-id="element-84">"RESET"</strong> por WhatsApp ahora, te mando el
              PDF + tracker, y en 7 días sentís la diferencia.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.6} className="space-y-8" data-id="element-85">
          <p className="text-xl text-offwhite-dim" data-id="element-86">
            No te pido perfección. Te pido 7 días.
          </p>
          <p className="text-2xl md:text-3xl font-heading font-bold text-amber" data-id="element-87">
            Un día a la vez. Con sistema. Con acompañamiento.
          </p>
          <p className="text-xl font-medium text-sand" data-id="element-88">
            Escribí RESET → $47 esta semana (quedan 5 cupos)
          </p>
          <p className="italic text-offwhite-dim" data-id="element-89">
            Método RESET: Regulación + Claridad + Dirección
          </p>

          <div className="pt-8" data-id="element-90">
            <Button href="https://wa.link/we351n" size="lg" withArrow className="shadow-2xl shadow-sand/20 w-full md:w-auto" data-id="element-91">
              WhatsApp: "RESET"
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}